const axios = require('axios');
const qs = require('qs');

const request = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL || '/',
  timeout: 15000,
  headers: { Pragma: 'no-cache' },
});

const redirect = function (url) {
  let dstUrl = url;
  if (process.env.NODE_ENV === 'development') {
    dstUrl = process.env.VUE_APP_PUBLIC_URL + url.split('/').pop();
  }
  if (window.location.href.indexOf('/consent') > 0) {
    window.location.replace(dstUrl);
  } else {
    window.location.assign(dstUrl);
  }
};

request.interceptors.response.use(
  (response) => {
    if (response.data && response.data.data && response.data.data.location) {
      const { location } = response.data.data;
      if (location.indexOf('/oauth2') > 0) {
        sessionStorage.clear();
      }
      redirect(location);
    }

    return response;
  },
  error => Promise.reject(error),
);

export const prepareLogin = challenge => request.get(`api/login/prepare?login_challenge=${challenge}`);

export const login = payload => request.post('login', qs.stringify(payload));

export const prepareConsent = challenge => request.get(`api/consent/prepare?consent_challenge=${challenge}`);

export const consent = payload => request.post(
  'consent',
  qs.stringify(payload, {
    arrayFormat: 'repeat',
  }),
);

export const freshCaptcha = () => request.get('api/captcha/generate');

export const sendSMS = (account, payload, directly = false) => {
  let encodeAccount = account;
  try {
    encodeAccount = btoa(account);
  } catch (err) {
    return Promise.reject(err);
  }

  return request.post(
    `api/accounts/sendsms?r=${encodeAccount}${directly ? '&m=1' : ''}`,
    qs.stringify(payload),
  );
};

export const verifypwd = (payload) => {
  let accountB64;
  try {
    accountB64 = btoa(payload.account);
  } catch (err) {
    return Promise.reject(err);
  }

  return request.post(
    `verifypwd?u=${accountB64}&c=${payload.challenge}`,
    qs.stringify(payload),
  );
};

export const getPwdRules = () => request.get('api/accounts/password/properties/get');

export const changepwd = payload => request.post('changepwd', qs.stringify(payload));

export const bindphone = payload => request.post('bindphone', qs.stringify(payload));

export const findpwd = payload => request.post('findpwd', qs.stringify(payload));

export const verifyphone = payload => request.post('verifyphone', qs.stringify(payload));

export const verifysms = payload => request.post('verifysms', qs.stringify(payload));

export const resetpwd = payload => request.post('resetpwd', qs.stringify(payload));

export const fetchLogo = () => request.get('../../api/site/menu/homeLogo');

export const pwdShow = () => request.get('api/login/password/show');

export const getWeakDictService = () => request.get('../../api/usermgnt/getWeakDictService');

export default {
  prepareLogin,
  login,
  prepareConsent,
  consent,
  freshCaptcha,
  pwdShow,
  getWeakDictService,
  sendSMS,
  verifypwd,
  getPwdRules,
  changepwd,
  bindphone,
  findpwd,
  verifyphone,
  verifysms,
  resetpwd,
  fetchLogo,
};
